import { render, staticRenderFns } from "./SaleToolbar.vue?vue&type=template&id=2ff7a565&scoped=true&lang=pug&"
import script from "./SaleToolbar.vue?vue&type=script&lang=js&"
export * from "./SaleToolbar.vue?vue&type=script&lang=js&"
import style0 from "./SaleToolbar.vue?vue&type=style&index=0&id=2ff7a565&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff7a565",
  null
  
)

component.options.__file = "SaleToolbar.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VToolbar,
})
